/* eslint-disable @typescript-eslint/no-unsafe-assignment -- @tanium/react-emotion (Emotion 11) styled() is typed via @emotion/styled/base, which typescript-eslint sees as `any`; tsc passes. This file is exclusively styled definitions. */
import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeColors } from '@tanium/theme-data';
import { HEX_646A7E } from '@tanium/colors';

export const SmallText = styled('span')(
  css({
    fontSize: 12,
  })
);

export const SmallBoldText = styled(SmallText)(
  css({
    fontWeight: 'bold',
  })
);

export const SmallSubtleText = styled(SmallText)(
  css({
    color: ThemeColors.TextSecondary,
    fontWeight: 'normal',
  })
);

export const SmallSecondaryText = styled(SmallText)(
  css({
    color: ThemeColors.TextSecondary,
  })
);

export const MediumText = styled('span')(
  css({
    fontSize: 14,
  })
);

export const MediumSubtleText = styled(MediumText)(
  css({
    color: ThemeColors.TextSecondary,
    fontWeight: 'normal',
  })
);

export const MediumHighlightedText = styled(MediumText)(
  css({
    color: ThemeColors.Action,
    fontWeight: 'normal',
  })
);

export const MediumBoldText = styled(MediumText)(
  css({
    fontWeight: 'bold',
  })
);

export const MediumBoldItalicText = styled(MediumText)(
  css({
    fontWeight: 'bold',
    fontStyle: 'italic',
  })
);

export const MediumBoldSubtleText = styled(MediumText)(
  css({
    color: ThemeColors.TextSecondary,
    fontWeight: 'bold',
  })
);

export const LargeText = styled('span')(
  css({
    fontSize: 16,
  })
);

export const LargeBoldText = styled('span')(
  css({
    fontSize: 16,
    fontWeight: 'bold',
  })
);

export const PageTitleText = styled('h1')(
  css({
    margin: 0,
    fontSize: 20,
    fontWeight: 'bold',
    color: ThemeColors.TextPrimary,
  })
);

export const TitleBoldText = styled('span')(
  css({
    fontSize: 18,
    fontWeight: 'bold',
  })
);

export const HeaderBoldText = styled('span')(
  css({
    fontSize: 32,
    fontWeight: 'bold',
  })
);

export const HoverText = styled('span')(
  css({
    borderBottom: `1px dashed ${HEX_646A7E}`,
  })
);
